import React from 'react'
import './style.sass'

export default function CartHeaderCount(props) {
    const {
        ruta = '/login', 
        cantidad = 0
    } = props


    return(
        <a
            href={ruta}
            className="cartIcon"
            aria-label="Ir a Carrito"
        >
            <span className="contCart">{cantidad > 99 ? '+99' : cantidad}</span>
            <span className="textReference">
                <span className="smallText"></span>
            </span>
        </a>
    )
}